export default "__VITE_ASSET__rNn$z9qF__"